import { render, staticRenderFns } from "./UploadFilesAlert.vue?vue&type=template&id=7aa9e0a2&scoped=true&"
import script from "./UploadFilesAlert.vue?vue&type=script&lang=js&"
export * from "./UploadFilesAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa9e0a2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
